import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { getUiComponent } from '../create-editor';
import { CoreEditor } from './core-editor';
export function ComposableEditor(props) {
  var AppearanceComponent = useMemo(function () {
    return getUiComponent(props.appearance);
  }, [props.appearance]);
  return /*#__PURE__*/React.createElement(CoreEditor, _extends({}, props, {
    AppearanceComponent: AppearanceComponent
  }));
}